// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "links", "item", "edit", "taskList", "taskItem", "name", "dueDate", "editField" ]

  connect() {

  }

  markComplete(event) {
    let taskId = this.data.get("id")
    if (event.currentTarget.checked == true) {
      event.currentTarget.parentElement.nextElementSibling.nextElementSibling.classList.add("dashed")
      event.currentTarget.parentElement.parentElement.classList.add("task-completed")
      event.currentTarget.parentElement.nextElementSibling.nextElementSibling.classList.remove("not-dashed")
      this.updateTask(taskId, true, true)
    } else {
      event.currentTarget.parentElement.nextElementSibling.nextElementSibling.classList.remove("dashed")
      event.currentTarget.parentElement.parentElement.classList.remove("task-completed")
      event.currentTarget.parentElement.nextElementSibling.nextElementSibling.classList.add("not-dashed")
      this.updateTask(taskId, false, true)
    }
  }

  markVerified(event) {
    let taskId = this.data.get("id")
    event.currentTarget.innerText = "Done!"
    event.currentTarget.classList.add("btn-success")
    event.currentTarget.classList.remove("btn-outline-success")
    this.verifyTask(taskId)
  }

  updateTask(id, complete, verify) {
    fetch(`/tasks/${id}/toggle`, {
      method: 'POST', // or 'PUT'
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({verify: verify}),
    })
    .then((response) => response)
    .then((data) => {
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  verifyTask(id) {
    fetch(`/tasks/${id}/verify`, {
      method: 'POST', // or 'PUT'
      body: "",
    })
    .then((response) => response)
    .then((data) => {
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  onPostSuccess(event) {
    let [data, status, xhr] = event.detail;
  }

  onPostDeleteSuccess(event) {
    console.log("deleted");
    let [data, status, xhr] = event.detail;
  }
}
